import { render, staticRenderFns } from "./inscripcion.vue?vue&type=template&id=68857a56&scoped=true&"
import script from "./inscripcion.vue?vue&type=script&lang=js&"
export * from "./inscripcion.vue?vue&type=script&lang=js&"
import style0 from "./inscripcion.vue?vue&type=style&index=0&id=68857a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68857a56",
  null
  
)

export default component.exports